import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import ContentCard from '../../../common/ContentCard';
import ImageGallery from 'react-image-gallery';
import { Modal } from 'react-bootstrap';
import { PICTURE_TYPE } from './constants';
import { DROPDOWN_VARIANTS } from '../../../common/constants';
import LoadingComponent from '../../../common/LoadingComponent';
import { segmentPhotosRequested } from '../actions';
import { getSegmentPhotos, getSegmentPhotosLoading } from '../selectors';
import SegmentIntroIcon from '../../../icons/horizonIcon.svg';
import BinsIcon from '../../../icons/binIcon.svg';
import HotspotsIcon from '../../../icons/hotspotIcon.svg';
import LitterIcon from '../../../icons/litterIcon.svg';
import CollectedIcon from '../../../icons/collectedIcon.svg';
import LeftNav from '../../../icons/arrowLeft.svg';
import RightNav from '../../../icons/arrowRight.svg';
import CloseIcon from '../../../icons/close-normal.svg';
import { PICTURE_LABELS } from './constants';
import BoundingBox from '../../../common/BoundingBox';
import './styles.scss';

function SegmentPhotos({ id, segmentId, loading, photos, getPhotos, userId }) {
    useEffect(() => {
        if (!photos) {
            getPhotos(segmentId, userId);
        }
    }, []);
    const [showGallery, setShowGallery] = useState(false);
    const [currentIndex, setCurrentIndexGallery] = useState(0);
    const [filter, setFilter] = useState('');
    const loader = <LoadingComponent isLoading={loading} />;

    // format bounding boxes from mongodb into format for <BoundingBox/> component
    const formatBoundingBoxes = (boundingBoxArray) => {
        let formattedArray = [];

        if (
            boundingBoxArray &&
            boundingBoxArray[0] &&
            boundingBoxArray[0].length > 0
        ) {
            // iterate over each bounding box in bounding box array
            formattedArray = boundingBoxArray.map((boundingBox) => {
                return [
                    boundingBox[0][0],
                    boundingBox[0][1],
                    boundingBox[1][0] - boundingBox[0][0],
                    boundingBox[1][1] - boundingBox[0][1],
                ];
            });
        }

        return formattedArray;
    };

    const filteredPhotos = filter
        ? photos.filter((p) => p.classification == filter)
        : photos;

    const mainContent = loading ? (
        loader
    ) : (
        <div>
            <div className="segment-photos custom-scroll">
                {filteredPhotos &&
                    [
                        [
                            SegmentIntroIcon,
                            PICTURE_LABELS.SEGMENT_INTRO,
                            'Horizon',
                        ],
                        [LitterIcon, PICTURE_LABELS.LITTER, 'Litter'],
                        [BinsIcon, PICTURE_LABELS.BIN, 'Bin'],
                        [HotspotsIcon, PICTURE_LABELS.HOTSPOT, 'Hotspot'],
                        [CollectedIcon, PICTURE_LABELS.BAGGAGE, 'Collected'],
                    ]
                        .filter((cat) =>
                            filteredPhotos.some(
                                (ph) => ph.classification == cat[1],
                            ),
                        )
                        .map((category) => (
                            <div className="classification" key={category[2]}>
                                <div>
                                    <img src={category[0]} />
                                    <label>{category[2]}</label>
                                </div>
                                <div>
                                    {filteredPhotos
                                        .filter(
                                            (photo) =>
                                                photo.classification ==
                                                category[1],
                                        )
                                        .map((photo) => (
                                            <span
                                                key={photo.id}
                                                className="thumbnail"
                                            >
                                                <img
                                                    className="image"
                                                    key={photo.id}
                                                    src={photo.thumbnail}
                                                    onClick={() => {
                                                        const index = filteredPhotos
                                                            .map((a) => a.id)
                                                            .indexOf(photo.id);
                                                        setCurrentIndexGallery(
                                                            index,
                                                        );
                                                        setShowGallery(true);
                                                    }}
                                                />
                                                {(photo.litterCount ||
                                                    photo.litterCount == 0) &&
                                                photo.posData &&
                                                photo.type == 'MULTI_LITTER' ? (
                                                    <label className="litter-count">
                                                        {photo.litterCount}
                                                    </label>
                                                ) : null}
                                            </span>
                                        ))}
                                </div>
                            </div>
                        ))}
                {photos && (
                    <Modal
                        show={showGallery}
                        onHide={() => {
                            setCurrentIndexGallery(0);
                            setShowGallery(false);
                        }}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        className="segment-image-gallery-modal"
                        centered={true}
                        animation={false}
                    >
                        <img
                            src={CloseIcon}
                            onClick={() => {
                                setCurrentIndexGallery(0);
                                setShowGallery(false);
                            }}
                            className="close-gallery"
                        />
                        <ImageGallery
                            showBullets={false}
                            showThumbnails={false}
                            showPlayButton={false}
                            showFullscreenButton={false}
                            showNav={true}
                            autoPlay={false}
                            infinite={false}
                            renderItem={(item) => {
                                // format bounding boxes for <BoundingBox />
                                const formattedBoundingBoxes = formatBoundingBoxes(
                                    item.posData,
                                );

                                return (
                                    <BoundingBox
                                        image={item.original}
                                        boxes={formattedBoundingBoxes || []}
                                    />
                                );
                            }}
                            items={filteredPhotos.map((photo) => ({
                                original: photo.photo,
                                thumbnail: photo.thumbnail,
                                originalClass: 'carousal-image',
                                posData: photo.posData,
                            }))}
                            renderLeftNav={(onClick, disabled) => {
                                return (
                                    <input
                                        type="image"
                                        src={LeftNav}
                                        disabled={disabled}
                                        onClick={onClick}
                                        className="image-gallery-icon image-gallery-left-nav image-gallery-custom-nav"
                                    />
                                );
                            }}
                            renderRightNav={(onClick, disabled) => {
                                return (
                                    <input
                                        type="image"
                                        src={RightNav}
                                        disabled={disabled}
                                        onClick={onClick}
                                        className="image-gallery-icon image-gallery-right-nav image-gallery-custom-nav"
                                    />
                                );
                            }}
                            startIndex={currentIndex}
                        />
                    </Modal>
                )}
            </div>
        </div>
    );

    return (
        <ContentCard
            heading={' '}
            showDropDown={true}
            dropDownData={PICTURE_TYPE}
            dropDownLabel={'Show'}
            dropDownOnClick={setFilter}
            dropDownVariant={DROPDOWN_VARIANTS.LIST_SIMPLE}
            content={mainContent}
            cardSize={7}
            id={id}
        />
    );
}

SegmentPhotos.propTypes = {
    id: PropTypes.string,
    segmentId: PropTypes.string,
    photos: PropTypes.array,
    getPhotos: PropTypes.func,
    loading: PropTypes.bool,
    userId: PropTypes.string,
};

SegmentPhotos.defaultProps = {
    id: 'segmentPhotos',
};

const mapStateToProps = (state) => {
    return {
        photos: getSegmentPhotos(state),
        loading: getSegmentPhotosLoading(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPhotos: (segmentId, userId) =>
            dispatch(segmentPhotosRequested(segmentId, userId)),
    };
};

const ConnectedSegmentPhotos = connect(
    mapStateToProps,
    mapDispatchToProps,
)(SegmentPhotos);

export default ConnectedSegmentPhotos;
